export const manifest = {
  screens: {
    scr_djm1ks: { name: "Inicio", route: "/#hero", position: {"x":160,"y":220} },
    scr_os6elq: { name: "Servicios", route: "/#servicios", position: {"x":1560,"y":220} },
    scr_rcy9qj: { name: "Galería", route: "/#galeria", position: {"x":2960,"y":220} },
    scr_7oswth: { name: "Precios", route: "/#precios", position: {"x":4360,"y":220} },
    scr_tnpsx3: { name: "Horarios", route: "/#horarios", position: {"x":7160,"y":220} },
    scr_zhum23: { name: "Nosotros", route: "/#nosotros", position: {"x":5760,"y":220} },
  },
  sections: {
    sec_vwzh30: { name: "Main Navigation", x: 0, y: 0, width: 8520, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_vwzh30", children: [
      { kind: "screen", id: "scr_djm1ks" },
      { kind: "screen", id: "scr_os6elq" },
      { kind: "screen", id: "scr_rcy9qj" },
      { kind: "screen", id: "scr_7oswth" },
      { kind: "screen", id: "scr_zhum23" },
      { kind: "screen", id: "scr_tnpsx3" },
    ] },
  ],
}
